import { MijnRoute } from '../../mijn-navigatie.model';

export const PAYMENT_BATCHES_AFGEROND_BESTAND: MijnRoute = {
    path: 'afgerond-bestand',
    navigationEvent: 'toBetaalbatchesAfgerondBestand',
    regex: /^\/betaalbatches\/afgerond-bestand$/,
    webcomponent: 'mijn-betalen-betaalbatches-webcomponent',
    internalPath: '/afgerond-bestand'
};
